/**
 * Unauthorized (401 page)
 *
 * Presents a friendly 401 screen and prevents browser back navigation while active
 * by pushing a history state and intercepting popstate. Offers a single action to
 * log out and return to the landing page, clearing local storage and using MSAL
 * logoutRedirect when an account is present.
 */
import React, { useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import { useMsal } from "@azure/msal-react";
import { routes } from "../../../constants/routes";
import Cookies from "js-cookie";

const Unauthorized = () => {
  const { instance } = useMsal();
  useEffect(() => {
    const handlePopState = () => {
      globalThis.history.pushState(null, "", globalThis.location.href);
    };

    globalThis.history.pushState(null, "", globalThis.location.href);
    globalThis.addEventListener("popstate", handlePopState);

    return () => {
      globalThis.removeEventListener("popstate", handlePopState);
    };
  }, []);
  const handleLogout = () => {
    const hostUrl = globalThis.location.origin;
    const accounts = instance.getAllAccounts();
    const logoutRequest = {
      account: accounts?.[0],
      postLogoutRedirectUri: `${hostUrl}${routes.LANDING}`,
    };
    if (accounts.length > 0) {
      instance.logoutRedirect(logoutRequest);
      setTimeout(() => {
        localStorage.clear();
        Cookies.remove("userDetails");
      }, 100);
    } else {
      localStorage.clear();
      Cookies.remove("userDetails");
      globalThis.location.href = routes.LANDING;
    }
  };
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      bgcolor="#f7f7f7"
      textAlign="center"
      px={3}
    >
      <LockIcon sx={{ fontSize: 80, color: "#403c6f", mb: 2 }} />
      <Typography variant="h4" fontWeight="bold">
        401 - Unauthorized
      </Typography>
      <Typography variant="body1" color="textSecondary" mt={1} mb={3}>
        You don’t have permission to access this page.
      </Typography>
      <Button
        variant="contained"
        sx={{
          backgroundColor: "#403c6f",
          "&:hover": { backgroundColor: "#403c6f" },
          color: "#fff",
          fontWeight: "bold",
          px: 3,
          py: 1,
          borderRadius: "8px",
        }}
        onClick={handleLogout}
      >
        Logout & Login Again
      </Button>
    </Box>
  );
};

export default Unauthorized;
